// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zqSc","title":"styles_title__2VMSB"};